import Navbar from '../../components/feature/Navbar';
import HeroSection from '../../components/feature/HeroSection';
import ServicesSection from '../../components/feature/ServicesSection';
import GallerySection from '../../components/feature/GallerySection';
import TestimonialsSection from '../../components/feature/TestimonialsSection';
import AboutSection from '../../components/feature/AboutSection';
import ContactSection from '../../components/feature/ContactSection';
import Footer from '../../components/feature/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <HeroSection />
        <ServicesSection />
        <GallerySection />
        <TestimonialsSection />
        <AboutSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}